module.exports = __webpack_public_path__ + "img/guizebeijing.2af3c0df.png";